/**
 * The module's permissions. Values, not types: the backend's manifest
 * registers them and the frontend gates on the same strings, so there is one
 * list.
 */
export const MESSAGING_PERMISSIONS = {
    /** Send a message, and search the directory for whom to send it to. */
    SEND: 'message.send',
};
/**
 * Bounds the server enforces, exported so a form can show them before the
 * server refuses. The server is the enforcement; these are the same numbers.
 */
export const MESSAGE_LIMITS = {
    subjectLength: 200,
    /**
     * Characters, not bytes. MySQL's `text` holds 65,535 bytes and UTF-8 spends
     * up to four per character, so 16,000 always fits — and `mediumtext`, which
     * would hold more, is not portable.
     */
    bodyLength: 16_000,
    /** People, after groups are expanded. Over it, a send fails rather than truncating. */
    recipients: 200,
    /** Entries in `to` — users and groups as the sender named them. */
    addresses: 50,
};
//# sourceMappingURL=messaging.js.map